<div class="form-container">
  <form [formGroup]="dynamicForm" (ngSubmit)="submitForm()">
    <div *ngFor="let row of data.formElements">
      <div class="adc-d-flex adc-gap-3 adc-mb20">
        <div *ngFor="let item of row.elements" class="adc-flex-fill">

          <!-- Textbox -->
          <div *ngIf="item.type == 'textbox'" [ngClass]="adcPrimaryIptStyle" [ngStyle]="item.customStyle">
            <label for="{{ item.id }}">{{ item.label | translate }}
              <span *ngIf="isRequiredValidator(item.validators)" class="adc-cl-red">*</span>
            </label>
            <input 
              [type]="item.inputType" 
              class="adc-mt2" 
              placeholder="{{ item.placeholder }}" 
              id="{{ item.id }}" 
              [formControlName]="item.name"
              [disabled]="item.isDisabled"
              [attr.pattern]="item.pattern ? item.pattern : null"/>
            <div *ngIf="dynamicForm.get(item.name)?.invalid && dynamicForm.get(item.name)?.touched">
              <small class="adc-cl-red" *ngIf="dynamicForm.get(item.name)?.hasError('required')">This field is required.</small>
              <small class="adc-cl-red" *ngIf="dynamicForm.get(item.name)?.hasError('whitespace')">Input cannot be empty or whitespace.</small>
              <small class="adc-cl-red" *ngIf="dynamicForm.get(item.name)?.hasError('email')">Invalid email format.</small>
              <small class="adc-cl-red" *ngIf="dynamicForm.get(item.name)?.hasError('customEmailPattern')">Invalid email format.</small>
              <small class="adc-cl-red" *ngIf="dynamicForm.get(item.name)?.hasError('pattern')">
                <ng-container *ngIf="item.name === 'zipcode'">Invalid zip code format.</ng-container>
                <ng-container *ngIf="item.name === 'phone'">Invalid phone number format.</ng-container>
                Invalid format.
              </small>
              <small class="adc-cl-red" *ngIf="dynamicForm.get(item.name)?.hasError('minZip')">ZIP code is too short. It should be at least 5 digits.</small>
              <small class="adc-cl-red" *ngIf="dynamicForm.get(item.name)?.hasError('maxZip')">ZIP code is too long. It should be no more than 10 digits.</small>
              <small class="adc-cl-red" *ngIf="dynamicForm.get(item.name)?.hasError('invalidFormat')">Invalid ZIP code format. It should contain only digits.</small>
            </div>
          </div>
          

          <!-- Textarea -->
          <div *ngIf="item.type == 'textarea'" [ngClass]="adcPrimaryIptStyle" [ngStyle]="item.customStyle">
            <label for="{{ item.id }}">{{ item.label | translate }}
              <span *ngIf="isRequiredValidator(item.validators)" class="adc-cl-red">*</span>
            </label>
            <textarea 
              placeholder="{{ item.placeholder }}" 
              id="{{ item.id }}" 
              [formControlName]="item.name"
              [ngStyle]="item.customStyle ? item.customStyle.textarea : {}" 
              rows="3"></textarea>
            <div *ngIf="dynamicForm.get(item.name)?.invalid && dynamicForm.get(item.name)?.touched">
              <small class="adc-cl-red" *ngIf="dynamicForm.get(item.name)?.hasError('required')">This field is required.</small>
              <small class="adc-cl-red" *ngIf="dynamicForm.get(item.name)?.hasError('minlength')">Minimum length is {{ dynamicForm.get(item.name)?.errors?.['minlength']?.requiredLength }}.</small>
            </div>
          </div>

          <!-- Checkbox -->
          <div *ngIf="item.type == 'checkbox'" [ngClass]="item.customClass" [ngStyle]="item.customStyle">
            <input 
              type="checkbox" 
              id="{{item.id}}" 
              [formControlName]="item.name"
              [attr.disabled]="item.disabled ? true : null"/>
            <label for="{{item.id}}">
              {{ item.label | translate }}
            </label>
          </div>

          <!-- Checkbox Vertical -->
          <div *ngIf="item.type == 'checkbox-vertical'" [ngClass]="item.customClass" [ngStyle]="item.customStyle">
            <div *ngFor="let i of item.items">
              <input 
                type="checkbox" 
                id="{{i.id}}" 
                [formControlName]="i.name"
                [attr.disabled]="i.disabled ? true : null"/>
              <label for="{{i.id}}">
                {{ i.label | translate }}
              </label>
            </div>
          </div>

          <!-- Checkbox Horizontal -->
          <div *ngIf="item.type == 'checkbox-horizontal'" [ngClass]="item.customClass" [ngStyle]="item.customStyle">
            <div *ngFor="let i of item.items">
              <input 
                type="checkbox" 
                id="{{i.id}}" 
                [formControlName]="i.name"
                [attr.disabled]="i.disabled ? true : null"/>
              <label for="{{i.id}}">
                {{ i.label | translate }}
              </label>
            </div>
          </div>

          <!-- Radio -->
          <div *ngIf="item.type == 'radio'" [ngClass]="item.customClass" [ngStyle]="item.customStyle">
            <input 
              type="radio" 
              id="{{item.id}}" 
              [formControlName]="item.name"
              [attr.disabled]="item.disabled ? true : null"/>
            <label for="{{item.id}}">
              {{ item.label | translate }}
            </label>
          </div>

          <!-- Radio Horizontal -->
          <div *ngIf="item.type == 'radio-horizontal'" [ngClass]="item.customClass" [ngStyle]="item.customStyle">
            <div *ngFor="let i of item.items">
              <input 
                type="radio" 
                [name]="item.name" 
                id="{{i.id}}" 
                [formControlName]="i.name"
                [attr.disabled]="i.disabled ? true : null"/>
              <label for="{{i.id}}">
                {{ i.label | translate }}
              </label>
            </div>
          </div>

          <!-- Radio Vertical -->
          <div *ngIf="item.type == 'radio-vertical'" [ngClass]="item.customClass" [ngStyle]="item.customStyle">
            <div *ngFor="let i of item.items">
              <input 
                type="radio" 
                [name]="item.name" 
                id="{{i.id}}" 
                [formControlName]="i.name"
                [attr.disabled]="i.disabled ? true : null"/>
              <label for="{{i.id}}">
                {{ i.label | translate }}
              </label>
            </div>
          </div>

          <!-- Select -->
          <div *ngIf="item.type == 'select'" [ngClass]="item.customClass" [ngStyle]="item.customStyle">
            <label for="{{item.id}}">{{ item.label | translate }}</label>
            <select 
              [formControlName]="item.name" 
              class="adc-select adc-cursor-pointer adc-iptgrp-errtxt">
              <option *ngFor="let i of item.list" [value]="i.label">{{ i.label }}</option>
            </select>
            <div *ngIf="dynamicForm.get(item.name)?.invalid && dynamicForm.get(item.name)?.touched">
              <small class="adc-cl-red" *ngIf="dynamicForm.get(item.name)?.hasError('required')">This field is required.</small>
              <small class="adc-cl-red" *ngIf="dynamicForm.get(item.name)?.hasError('minlength')">Minimum length is {{ dynamicForm.get(item.name)?.errors?.['minlength']?.requiredLength }}.</small>
            </div>
          </div>

          <!-- Date-Time Input -->
          <div *ngIf="item.type == 'datetime-local'" [ngClass]="adcPrimaryIptStyle" [ngStyle]="item.customStyle">
            <label for="{{ item.id }}">{{ item.label | translate }}</label>
            <input 
              type="datetime-local" 
              class="adc-mt2" 
              id="{{ item.id }}" 
              [formControlName]="item.name"
              [disabled]="item.isDisabled"/>
            <div *ngIf="dynamicForm.get(item.name)?.invalid && dynamicForm.get(item.name)?.touched">
              <small class="adc-cl-red" *ngIf="dynamicForm.get(item.name)?.hasError('required')">This field is required.</small>
              <small class="adc-cl-red" *ngIf="dynamicForm.get(item.name)?.hasError('pattern')">Invalid date-time format.</small>
            </div>
          </div>

        </div>
      </div>
    </div>
  </form>
</div>
